import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSecureDataRequestText } from 'services/secureDataSharing';

export const ThunkGetSecureDataRequestText = createAsyncThunk(
  'secureDataSharing/getSecureDataRequestText',
  () => getSecureDataRequestText().then(r => r.data),
);
